import { Observer } from 'mobx-react-lite';
import React from 'react';
import { AnyObject } from '../../base/@types';
import { useFormContext } from '../../base/components/FormForm/Form.context';
import { Form } from '../../base/mediators/form.mediator';
import joinClassName from '../../base/utils/className.utils';
import { useProps, useStore } from '../../base/utils/mobx.utils';
import FacilitatorSelector, { FacilitatorSelectorProps } from '../FacilitatorSelector/FacilitatorSelector';
// import './FormFacilitatorSelector.scss';

type FormFacilitatorSelectorProps<T extends AnyObject = AnyObject> = Omit<FacilitatorSelectorProps, 'form'> & {
  form?: Form<T>,
}

function FormFacilitatorSelector<T extends AnyObject = AnyObject>(
  props: React.PropsWithChildren<FormFacilitatorSelectorProps<T>>
) {

  const context = useFormContext<T>();
  const { form } = context;
  const p = useProps(props);
  const s = useStore(() => ({
    get form() { return p.form ?? form },
  }));

  return <Observer children={() => (
    <FacilitatorSelector {...p}
      className={joinClassName('FormFacilitatorSelector', p.className)}
      form={s.form.fields[p.field]}
      field="value"
      name={p.name ?? p.field}
      disabled={p.disabled || context.disabled}
    />
  )} />
}

export default FormFacilitatorSelector;